var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-view",
    [
      _c("secondary-navigation-bar", {
        attrs: {
          navigation: _vm.navigation,
          "data-qa-prefix": "backer-center",
        },
      }),
      _vm._v(" "),
      _c(
        "main",
        { class: ["gfu-layout__main _pt-4 _pt-6--m", _vm.layoutClasses] },
        [
          _c("base-title", { attrs: { as: "h1", level: "h1" } }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _c("return-to-element", { attrs: { "element-id": "js-main-header" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }